import { FormFieldDefinitionWithConstraints } from '@publishing-engine/domain/models/form-schema';
import {
  FormFieldDefinition,
  FormFieldSelect
} from '@publishing-engine/domain/types/article';
import { jsonSchemaFromFormFieldDefinitionsAndConstraints } from '@publishing-engine/submission-service/src/usecases/form-schema/json-schema-from-form-field-definition';
import { SubmissionFormFields } from '@publishing-engine/submission-service/src/workflow-configuration/submission-fields/submission-form-fields';
import { JSONSchemaType } from 'ajv';

export const generateValidationSchema = (
  configs: Record<string, FormFieldDefinition | null>
) => {
  const fields: FormFieldDefinitionWithConstraints[] = [];

  for (const value of Object.values(configs)) {
    if (value) {
      fields.push({
        formFieldDefinition: value
      });
    }
  }

  return jsonSchemaFromFormFieldDefinitionsAndConstraints(
    fields
  ) as JSONSchemaType<any>;
};

export const getSubmissionFormFieldConfigs = (
  submissionFormFields: SubmissionFormFields
) =>
  ({
    Manuscript: submissionFormFields.getFieldConfig('Manuscript')!,
    Title: submissionFormFields.getFieldConfig('Title')!,
    Abstract: submissionFormFields.getFieldConfig('Abstract')!,
    Keywords: submissionFormFields.getFieldConfig('Keywords'),
    CoverLetter: submissionFormFields.getFieldConfig('CoverLetter'),
    EthicsStatement: submissionFormFields.getFieldConfig('EthicsStatement'),
    NoveltyStatement: submissionFormFields.getFieldConfig('NoveltyStatement'),
    FiguresAndTables: submissionFormFields.getFieldConfig('FiguresAndTables'),
    LicensesAndPermissions: submissionFormFields.getFieldConfig(
      'LicensesAndPermissions'
    ),
    LicensesAndPermissionsReproducedContent:
      submissionFormFields.getFieldConfig(
        'LicensesAndPermissionsReproducedContent'
      ),
    LicensesAndPermissionsFiles: submissionFormFields.getFieldConfig(
      'LicensesAndPermissionsFiles'
    ),
    AdditionalFiles: submissionFormFields.getFieldConfig('AdditionalFiles'),
    Funding: submissionFormFields.getFieldConfig('Funding'),
    SubmittingAuthor: submissionFormFields.getFieldConfig('SubmittingAuthor')!,
    ContactAuthor: submissionFormFields.getFieldConfig('ContactAuthor')!,
    CorrespondingAuthor: submissionFormFields.getFieldConfig(
      'CorrespondingAuthor'
    )!,
    CoAuthors: submissionFormFields.getFieldConfig('Authors'),
    Supplementary: submissionFormFields.getFieldConfig('Supplementary'),
    PublishingModel: submissionFormFields.getFieldConfig('PublishingModel')!,
    DataAvailability: submissionFormFields.getFieldConfig('DataAvailability'),
    DoubleAnonymousPeerReview: submissionFormFields.getFieldConfig(
      'DoubleAnonymousPeerReview'
    ),
    TransparentPeerReview: submissionFormFields.getFieldConfig(
      'TransparentPeerReview'
    ),
    ImmediatePublication: submissionFormFields.getFieldConfig(
      'PreferenceImmediatePublication'
    ),
    SupplementaryUpload: submissionFormFields.getFieldConfig('Supplementary'),
    PreferenceImmediatePublication: submissionFormFields.getFieldConfig(
      'PreferenceImmediatePublication'
    ),
    AnonymizedManuscript: submissionFormFields.getFieldConfig(
      'AnonymizedManuscript'
    ),
    RecommendedReviewers: submissionFormFields.getFieldConfig(
      'RecommendedReviewers'
    ),
    OpposedReviewers: submissionFormFields.getFieldConfig('OpposedReviewers'),
    ClinicalTrials: submissionFormFields.getFieldConfig('ClinicalTrials'),
    AcceleratedPublication: submissionFormFields.getFieldConfig(
      'AcceleratedPublication'
    ),
    IPEMMembership: submissionFormFields.getFieldConfig('IPEMMembership'),
    SubjectArea: submissionFormFields.getFieldConfig(
      'SubjectArea'
    ) as FormFieldSelect | null
  } as const);

export type ISubmissionFormFieldConfigs = ReturnType<
  typeof getSubmissionFormFieldConfigs
>;
